export default "__VITE_ASSET__DsN8F6tX__"